import { ModuleWithProviders } from '@angular/core';
import { DW_APP_AUTH_TOKEN, DW_MOCK } from '@webdpt/framework';
import { environment } from '../../environments/environment';
import { DigiMiddlewareAuthApp } from './app-auth-token';
var SystemModule = /** @class */ (function () {
    function SystemModule() {
    }
    SystemModule.forRoot = function (providers) {
        return {
            ngModule: SystemModule,
            providers: [
                {
                    provide: DW_MOCK,
                    useValue: environment.mock
                },
                {
                    provide: DW_APP_AUTH_TOKEN,
                    useValue: DigiMiddlewareAuthApp
                }
            ].concat(providers)
        };
    };
    return SystemModule;
}());
export { SystemModule };
